import { useTrackableState } from "../service/PageService";
import { Button, Stack, Divider, Typography } from "@mui/material";
import CardField from "../components/CardField/CardField";

import "./FoundedCarCardField.scss";

const FoundedCarCardField = ({ registry, events, ...args }) => {
  const [visible, setVisible] = useTrackableState(true);
  const [conducteurP, setConducteurP] = useTrackableState(
    args.conducteurP || ""
  );
  const [conducteurS, setConducteurS] = useTrackableState(
    args.conducteurS || ""
  );
  const [marque, setMarque] = useTrackableState(args.marque || "");
  const [model, setModel] = useTrackableState(args.model || "");
  const [versionMoteur, setVersionMoteur] = useTrackableState(
    args.versionMoteur || ""
  );
  const [remorque, setRemorque] = useTrackableState(args.remorque || false);
  const [formula, setFormula] = useTrackableState(args.formula || {});
  const [setValue] = useTrackableState({});

  if (args.code) {
    const api = {};

    Object.defineProperties(api, {
      visible: {
        get: () => visible,
        set: (v) => setVisible(v),
      },
      value: {
        get: () => {
          return [conducteurP, conducteurS, marque, model, formula];
        },
        set: (v) => setValue(v),
      },
      conducteurP: {
        get: () => conducteurP,
        set: (v) => setConducteurP(v),
      },
      conducteurS: {
        get: () => conducteurS,
        set: (v) => setConducteurS(v),
      },
      marque: {
        get: () => marque,
        set: (v) => setMarque(v),
      },
      model: {
        get: () => model,
        set: (v) => setModel(v),
      },
      versionMoteur: {
        get: () => versionMoteur,
        set: (v) => setVersionMoteur(v),
      },
      remorque: {
        get: () => remorque,
        set: (v) => setRemorque(v),
      },
      formula: {
        get: () => formula,
        set: (v) => setFormula(v),
      },
    });

    registry.set(args.code, api);
  }

  if (!visible) return <></>;

  return (
    <CardField selected={false} className={"FoundedCarItem"}>
      <Stack direction={"column"} spacing={3}>
        <Stack direction={"row"} justifyContent="space-between">
          <svg
            width="92"
            height="38"
            viewBox="0 0 92 38"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M91.4371 18.1967C90.9968 15.353 88.2916 12.9329 83.5733 11.1934C78.7399 9.55406 73.647 8.73519 68.522 8.77332C52.9044 -2.20804 33.5437 -2.64666 11.006 7.47253L4.22744 8.5464C3.18576 8.71451 2.23977 9.2322 1.55737 10.0076C0.874969 10.7829 0.500312 11.7658 0.5 12.7816V22.5076C0.502094 23.5352 0.887119 24.5279 1.58521 25.3059L3.94435 27.9377C4.35897 28.4081 4.87439 28.7868 5.4553 29.0479C6.0362 29.309 6.6689 29.4462 7.31009 29.4503H9.44902C9.89663 31.6331 11.1183 33.5988 12.9054 35.0116C14.6924 36.4245 16.934 37.1968 19.2474 37.1968C21.5607 37.1968 23.8023 36.4245 25.5893 35.0116C27.3764 33.5988 28.5981 31.6331 29.0457 29.4503H65.5966C66.0443 31.6331 67.2659 33.5988 69.0529 35.0116C70.8399 36.4245 73.0816 37.1968 75.3949 37.1968C77.7083 37.1968 79.9499 36.4245 81.737 35.0116C83.524 33.5988 84.7457 31.6331 85.1933 29.4503H87.0491C88.2296 29.4503 89.3617 28.9994 90.1964 28.1966C91.0311 27.3938 91.5 26.305 91.5 25.1697V18.227L91.4371 18.1967ZM75.3478 20.9799C76.7009 20.9799 78.0237 21.3658 79.1488 22.0888C80.2738 22.8117 81.1507 23.8393 81.6685 25.0416C82.1863 26.2439 82.3218 27.5669 82.0579 28.8432C81.7939 30.1196 81.1423 31.292 80.1855 32.2122C79.2287 33.1324 78.0096 33.759 76.6825 34.0129C75.3554 34.2668 73.9798 34.1365 72.7297 33.6385C71.4795 33.1405 70.4111 32.2972 69.6593 31.2151C68.9075 30.1331 68.5062 28.8609 68.5062 27.5596C68.5062 26.6955 68.6833 25.8399 69.0271 25.0416C69.3709 24.2433 69.8748 23.518 70.5101 22.907C71.1454 22.296 71.8996 21.8114 72.7297 21.4807C73.5597 21.1501 74.4494 20.9799 75.3478 20.9799ZM19.2002 20.9799C20.5533 20.9799 21.8761 21.3658 23.0011 22.0888C24.1262 22.8117 25.0031 23.8393 25.5209 25.0416C26.0387 26.2439 26.1742 27.5669 25.9102 28.8432C25.6462 30.1196 24.9947 31.292 24.0379 32.2122C23.0811 33.1324 21.862 33.759 20.5349 34.0129C19.2077 34.2668 17.8322 34.1365 16.582 33.6385C15.3319 33.1405 14.2634 32.2972 13.5117 31.2151C12.7599 30.1331 12.3587 28.8609 12.3587 27.5596C12.3587 26.6955 12.5356 25.8399 12.8795 25.0416C13.2233 24.2433 13.7272 23.518 14.3625 22.907C14.9978 22.296 15.752 21.8114 16.582 21.4807C17.4121 21.1501 18.3017 20.9799 19.2002 20.9799ZM32.2856 8.77332L29.9264 4.32632C42.2883 1.80031 53.0303 3.25239 62.75 8.77332H32.2856ZM6.74392 14.8237C6.74392 14.4225 6.57819 14.0378 6.28324 13.7541C5.98829 13.4705 5.58828 13.3111 5.17115 13.3111H3.59839V12.827C3.59769 12.5303 3.70624 12.2429 3.9049 12.0158C4.10356 11.7888 4.37948 11.6368 4.6836 11.5867L11.8711 10.4371L12.0755 10.3464C16.7974 8.17817 21.7141 6.42654 26.7651 5.1129L29.9107 10.9968L67.4054 11.7985H67.9401C72.115 11.7255 76.279 12.235 80.3019 13.3111L83.4475 18.6203C83.584 18.8539 83.7827 19.0484 84.0231 19.184C84.2636 19.3195 84.5371 19.3912 84.8158 19.3917H88.2601V25.0941C88.2628 25.4206 88.133 25.7353 87.8984 25.9714C87.7767 26.0884 87.6319 26.1808 87.4726 26.2431C87.3132 26.3054 87.1426 26.3365 86.9705 26.3344H85.2404C84.9501 24.0013 83.7806 21.8516 81.9532 20.2919C80.1258 18.7323 77.7674 17.871 75.3242 17.871C72.881 17.871 70.5225 18.7323 68.6951 20.2919C66.8678 21.8516 65.6983 24.0013 65.4079 26.3344H29.0772C28.7726 24.0138 27.5979 21.8798 25.7736 20.3329C23.9494 18.786 21.6008 17.9325 19.1687 17.9325C16.7366 17.9325 14.3881 18.786 12.5638 20.3329C10.7396 21.8798 9.5649 24.0138 9.2603 26.3344H7.23147C7.04456 26.3352 6.85952 26.2979 6.68872 26.2249C6.51792 26.1519 6.36523 26.0449 6.24062 25.9109L3.88148 23.279C3.68435 23.0483 3.57354 22.7607 3.56691 22.4622V16.2606H5.13967C5.55416 16.2688 5.95527 16.1192 6.25569 15.8445C6.55611 15.5697 6.73157 15.1919 6.74392 14.7934V14.8237ZM85.7595 16.427L85.0517 15.2471C85.6883 15.5826 86.2889 15.9778 86.8447 16.427H85.7595Z"
              fill="#3467CD"
            />
          </svg>

          <Stack direction={"column"}>
            <div>
              {marque} - {model}
            </div>
            <div className={"FoundedCarItem__Title2"}>{versionMoteur}</div>
            <div className={"FoundedCarItem__Title2"}>
              {remorque && `+ 1 remorque de + de 750 Kg`}
            </div>
          </Stack>
          <Button variant={"outlined"} color={"info"}>
            Modifier
          </Button>
        </Stack>
        <Divider variant="middle" />

        <Stack direction={"column"}>
          <Stack direction={"row"}>
            <div className={"FoundedCarItem__Title2"}>
              Conducteur principal :
            </div>
            <div className={"FoundedCarItem__Title1"}>
              {conducteurP || "M. John Wayne"}
            </div>
          </Stack>
          <Stack direction={"row"}>
            <div className={"FoundedCarItem__Title2"}>
              Conducteur secondaire :
            </div>
            <div className={"FoundedCarItem__Title1"}>{conducteurS || "-"}</div>
          </Stack>
        </Stack>
        <Divider variant="middle" />
        {formula ? (
          <Stack direction={"row"} spacing={3}>
            <Stack direction={"column"} spacing={1}>
              <div>Formule: {formula.name || ""}</div>
              <Button variant="contained" style={{ width: "fit-content" }}>
                modifier
              </Button>
            </Stack>
            <Stack direction={"column"} justifyContent="center">
              <Stack direction="row">
                <Typography style={{ fontSize: "16px" }}>
                  {formula.prime ? formula.prime : ""}€ TTC
                </Typography>
                <Typography style={{ fontSize: "12px" }}>/mois</Typography>
              </Stack>
              <Typography style={{ fontSize: "12px" }}>
                ou {(formula.prime * 12).toFixed(2) || ""} € TTC/an
              </Typography>
            </Stack>
          </Stack>
        ) : (
          <></>
        )}
      </Stack>
    </CardField>
  );
};

export default FoundedCarCardField;
